// This only purpose of this component is to redirect user to the original tab after they are done connecting instagram from new tab
// This will close the new tab and the brower will send them back to the original tab
export function GoBack() {
  window.close();
  return <></>;
}
